import { QuickWinsTabContent } from "./QuickWinsTabContent"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

export const SuggestedTabQuickWins = (props: TabComponentProps) => (
  <QuickWinsTabContent {...props} tab="suggested" />
)
SuggestedTabQuickWins.displayName = "SuggestedTabQuickWins"
